export default __webpack_public_path__ + "static/media/icons8-adventures-144.3adce402.png";